import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hospitality-bot-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
})
export class DialogHeaderComponent {
  @Input() title: string = '';
  @Input() heading?: string;
  @Input() subtitle?: string;
  @Input() icon?: string;
  @Input() iconClass?: string;
  @Input() showClose: boolean = true;
  @Output() onClose = new EventEmitter<void>();
  @Output() onModalClose = new EventEmitter<void>();

  get displayTitle(): string {
    return this.title || this.heading || '';
  }

  close(): void {
    this.onClose.emit();
    this.onModalClose.emit();
  }
}
